import React, { useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Feed from './components/Feed';
import Chats from './components/Chats';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  return (
    <div className="App">
      <div className="app-container">
        <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
        <div className="main-content">
          <Header />
          {currentPage === 'chats' ? <Chats /> : <Feed />}
        </div>
      </div>
    </div>
  );
}

export default App;
